import {
	Cookie,
	Component,
	IComponentBindings,
	Initialization
} from 'coveo-search-ui';
import { SearchAssist } from "./SearchAssist";
import { SearchHelper } from "./../models/SearchHelper";
import * as $ from 'jquery';
import * as _ from "underscore";

export class RecentSearches extends Component {
	static ID = 'RecentSearches';
	private template: any;
	private $listEl: JQuery;
	private $noTermsEl : JQuery;
	private searchHelper: SearchHelper = SearchHelper.Instance;

	constructor(public element: HTMLElement, public bindings: IComponentBindings) {
		super(element, RecentSearches.ID, bindings);
		this.$listEl = $(".result-list", this.element);
		this.$noTermsEl = $(".no-recent-searches", this.element);
		this.template = _.template($("script.result-template", this.element).html());
		
		this.renderDom(this.searchHelper.terms);
		this.renderNoTermsMessage();

		this.$listEl.on("click", "a", this.handleClick.bind(this));
		$(this.searchHelper).on(
			SearchHelper.recentSearchTermChangeEvent,
			(e, terms) => this.onRecentSearchTermChangeEvent(terms));
	}

	public onRecentSearchTermChangeEvent(terms: string[]) {
		this.resetDom();
		this.renderDom(terms);
		this.renderNoTermsMessage();
	}

	private getSearchAssist(): SearchAssist {
		var facetElement = (Coveo as any).$(".Coveo" + SearchAssist.ID);
		return facetElement.coveo(SearchAssist) as SearchAssist;
	}

	private handleClick() {
		this.getSearchAssist().hideMenu();
	}

	private renderNoTermsMessage() {
		var action = this.searchHelper.hasSearchTerms ? "hide" : "show";
		this.$noTermsEl[action]();
	}

	private resetDom() {
		this.$listEl.empty();
	}

	private renderDom(terms: string[]) {
		terms.forEach((term) => {
			var html = this.template({
				termUrlEncoded: encodeURIComponent(term),
				term: term
			});

			this.$listEl.append(html);
		});
	}
}

Initialization.registerAutoCreateComponent(RecentSearches);



// WEBPACK FOOTER //
// ./src/source/Atlas.SEF.Feature.Common/Areas/AtlasCommon/Assets/Search/components/RecentSearches.ts